import React, { useState, useRef, useEffect, useCallback } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  Button,
  PageHeader,
  Collapse,
  Row,
  Col,
  message,
  Input,
  Checkbox,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
  threeColumnFormItemLayout,
} from "../../utils/Layouts";

import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
  onDeleteItem,
} from "../../utils/form_utilities";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import {
  addKeysToArray,
  onCategorySearch,
  onStationSearch,
  onStockInventorySearch,
  onStockSearch,
  onSupplierSearch,
  onUnitOfMeasureSearch,
} from "../../utils/utilities";
import CategoryFormModal from "../modals/CategoryFormModal";

import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import {
  item_type_options,
  product_type_options,
  senior_discount_options,
} from "../../utils/Options";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import { authenticateAdmin } from "../../utils/authentications";
import RadioGroupFieldGroup from "../../commons/RadioGroupFieldGroup";
import { SENIOR_DISC_RATIO, MENU_ITEM } from "../../utils/constants";
import axios from "axios";
import { debounce } from "lodash";
import numberFormat from "../../utils/numberFormat";
import CheckboxGroupFieldGroup from "../../commons/CheckboxGroupFieldGroup";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined } from "@material-ui/icons";

const { Content } = Layout;
const { Panel } = Collapse;

const url = "/api/products/";
const title = "Products";

const date_fields = [];

export default function StockForm({ product_type, form_title }) {
  const history = useNavigate();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [raw_material, setRawMaterial] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page_size, setPageSize] = useState(100);
  const [display_raw_mats, setDisplayRawMats] = useState(false);

  const [branches, setBranches] = useState([]);
  const [options, setOptions] = useState({
    categories: [],
    subcategories: [],
    stocks: [],
    suppliers: [],
    brands: [],
  });

  const [search_state, setSearchState] = useState({
    category: null,
    product_type,
  });

  const initialRawMaterials = {
    raw_material: {
      name: "",
    },
    raw_material_quantity: "",
    variation: "",
  };
  const initialValues = {
    _id: null,
    name: "",
    sku: "",
    category: null,
    meat_type: null,
    price: "",
    price: "",
    uom: "",
    description: "",
    taxable: true,
    type_of_senior_discount: SENIOR_DISC_RATIO,
    reorder_level: "",
    pieces_in_case: "",
    disabled: false,
    raw_materials: [
      {
        ...initialRawMaterials,
      },
    ],
    specific_category: "",
    cost: "",
    is_open_item: false,
    track_inventory: false,
    product_type,
  };

  const [state, setState] = useState(initialValues);

  const categoryFormModal = useRef(null);

  const records_column = !display_raw_mats
    ? [
        {
          title: "Name",
          dataIndex: "name",
        },
        {
          title: "UOM",
          align: "center",
          dataIndex: ["unit_of_measure"],
        },
        {
          title: "Category",
          dataIndex: ["category"],
          render: (category, record, record_index) => {
            return record.product_type === MENU_ITEM ? (
              <SelectFieldGroup
                size="small"
                value={category?.name}
                onSearch={(value) =>
                  onCategorySearch({ value, options, setOptions })
                }
                onChange={(index) => {
                  const category = options.categories?.[index] || null;
                  setRecords((prevRecords) => {
                    let records = [...prevRecords];

                    records[record_index] = {
                      ...records[record_index],
                      category,
                    };

                    return records;
                  });
                }}
                onBlur={() => {
                  onSubmit({
                    values: record,
                    auth,
                    url,
                    setErrors,
                    setState,
                    date_fields,
                    setLoading,
                    cb: () => {
                      onSearch({
                        page: current_page,
                        page_size,
                        search_keyword,
                        url,
                        setRecords,
                        setTotalRecords,
                        setCurrentPage,
                        setErrors,
                        advance_search: {
                          ...search_state,
                          product_type,
                        },
                      });
                    },
                  });
                }}
                formItemLayout={smallFormItemLayout}
                data={options.categories}
                column="name"
                onAddItem={() => categoryFormModal.current.open()}
              />
            ) : (
              category?.name
            );
          },
        },
        {
          title: "Printer Station",
          dataIndex: ["printer_station"],
          render: (printer, record, record_index) => {
            return record.product_type === MENU_ITEM ? (
              <SelectFieldGroup
                size="small"
                name="printer_station"
                value={printer?.name}
                onChange={(index) => {
                  const printer_station = options.printers?.[index] || null;
                  setRecords((prevRecords) => {
                    let records = [...prevRecords];

                    records[record_index] = {
                      ...records[record_index],
                      printer_station,
                    };

                    return records;
                  });
                }}
                onSearch={onPrinterStationSearch}
                error={errors.printer_station}
                formItemLayout={smallFormItemLayout}
                data={options.printers}
                onFocus={() => {
                  onPrinterStationSearch("");
                }}
                onBlur={() => {
                  onSubmit({
                    values: record,
                    auth,
                    url,
                    setErrors,
                    setState,
                    date_fields,
                    setLoading,
                    cb: () => {
                      onSearch({
                        page: current_page,
                        page_size,
                        search_keyword,
                        url,
                        setRecords,
                        setTotalRecords,
                        setCurrentPage,
                        setErrors,
                        advance_search: {
                          ...search_state,
                          product_type,
                        },
                      });
                    },
                  });
                }}
              />
            ) : (
              printer?.name
            );
          },
        },
        {
          title: "Cost",
          dataIndex: ["cost"],
          align: "right",
          render: (cost) => numberFormat(cost),
        },
        {
          title: "Price",
          dataIndex: ["price"],
          width: 100,
          align: "right",
          render: (cost, record, record_index) => {
            return record.product_type === MENU_ITEM ? (
              <Row gutter={8}>
                <Col span={24}>
                  <Input
                    size="small"
                    type="number"
                    step={0.01}
                    className="has-text-right input-value"
                    value={cost}
                    onChange={(e) => {
                      const price = e.target.value;
                      setRecords((prevRecords) => {
                        let records = [...prevRecords];

                        records[record_index] = {
                          ...records[record_index],
                          price,
                        };

                        return records;
                      });
                    }}
                    onBlur={() => {
                      onSubmit({
                        values: record,
                        auth,
                        url,
                        setErrors,
                        setState,
                        date_fields,
                        setLoading,
                        cb: () => {
                          onSearch({
                            page: current_page,
                            page_size,
                            search_keyword,
                            url,
                            setRecords,
                            setTotalRecords,
                            setCurrentPage,
                            setErrors,
                            advance_search: {
                              ...search_state,
                              product_type,
                            },
                          });
                        },
                      });
                    }}
                    align="right"
                  />
                </Col>
              </Row>
            ) : (
              numberFormat(cost)
            );
          },
        },
      ]
    : [
        {
          title: "Product",
          dataIndex: "name",
        },
        {
          title: "Raw Materials",
          dataIndex: "raw_materials",
          render: (items) => (
            <div>
              {(items || []).map((item, item_index) => {
                return (
                  <div key={item_index}>
                    ({item.raw_material_quantity}){" "}
                    {item.raw_material?.name || ""} - {item.variation}
                  </div>
                );
              })}
            </div>
          ),
        },
      ];

  const raw_materials_column = [
    {
      title: "",
      key: "action",
      width: 30,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 && (
            <span
              onClick={() => {
                setState((prevState) => {
                  const items = [...prevState.items];

                  items.splice(index + 1, 0, {
                    ...initialRawMaterials,
                  });

                  return {
                    ...prevState,
                    items,
                  };
                });
              }}
            >
              <i className="fas fa-plus"></i>
            </span>
          )}
        </span>
      ),
    },
    {
      title: "Item",
      dataIndex: ["raw_material"],
      render: (stock, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={stock?.name}
              onSearch={(value) =>
                onStockSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const raw_material = options.stocks?.[index] || null;

                if (raw_material) {
                  setState((prevState) => {
                    const raw_materials = [...(prevState.raw_materials || [])];

                    raw_materials[record_index] = {
                      ...raw_materials[record_index],
                      raw_material,
                    };

                    if (raw_materials.length - 1 === record_index) {
                      raw_materials.push({
                        ...initialRawMaterials,
                        category: raw_materials[record_index].category,
                      });
                    }

                    return {
                      ...prevState,
                      raw_materials,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.stocks}
              column="display_name"
            />
          )
        );
      },
    },

    {
      title: "Qty",
      dataIndex: "raw_material_quantity",
      align: "right",
      width: 200,
      render: (value, record, index) =>
        record.footer !== 1 && (
          <Row gutter={8}>
            <Col span={24}>
              <Input
                type="number"
                step={0.01}
                className="has-text-right input-value"
                value={record.raw_material_quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  setState((prevState) => {
                    let raw_materials = [...state.raw_materials];

                    raw_materials[index] = {
                      ...raw_materials[index],
                      raw_material_quantity: value,
                    };

                    if (raw_materials.length - 1 === index) {
                      raw_materials.push({
                        ...initialRawMaterials,
                      });
                    }

                    return {
                      ...prevState,
                      raw_materials,
                    };
                  });
                }}
                align="right"
              />
            </Col>
          </Row>
        ),
    },
    {
      title: "",
      key: "action",
      width: 80,
      render: (text, record, index) => (
        <span
          onClick={() =>
            onDeleteItem({
              field: "raw_materials",
              index,
              setState,
            })
          }
        >
          <i className="fas fa-trash-alt"></i>
        </span>
      ),
    },
  ];

  const onPrinterStationSearch = debounce((value) => {
    axios
      .get(`/api/printer-stations/?s=${value}`)
      .then((response) =>
        setOptions((prevOptions) => ({
          ...prevOptions,
          printers: response.data,
        }))
      )
      .catch((err) => console.log(err));
  }, 200);

  //setup branch pricing
  useEffect(() => {
    setState((prevState) => {
      //check branch pricing and add branches that are not found
      let branch_pricing = [...(prevState.branch_pricing || [])];
      const branches_not_found = branches.filter((o) => {
        return !branch_pricing.map((_o) => _o.branch?._id).includes(o._id);
      });

      branch_pricing = [
        ...branch_pricing,
        ...branches_not_found.map((o) => {
          return {
            branch: o,
            price: "",
            wholesale_price: "",
          };
        }),
      ];

      return {
        ...prevState,
        branch_pricing,
      };
    });

    return () => {};
  }, [state._id, branches]);

  useEffect(() => {
    onCategorySearch({
      value: "",
      options,
      setOptions,
      is_menu: product_type ? true : false,
    });

    //get branches
    axios.get("/api/branches/listings").then((response) => {
      setBranches([...response.data]);
    });

    onSearch({
      page: 1,
      page_size,
      search_keyword,
      url,
      setRecords,
      setTotalRecords,
      setCurrentPage,
      setErrors,
      advance_search: {
        ...search_state,
        product_type,
      },
    });

    return () => {};
  }, [search_state.category, product_type]);

  useEffect(() => {
    authenticateAdmin({
      role: auth.user?.role,
      history,
    });
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <CategoryFormModal
        setField={(category) => {
          setState((prevState) => ({
            ...prevState,
            category,
          }));
        }}
        ref={categoryFormModal}
      />
      <Row>
        <Col span={8}>
          <Breadcrumb style={{ margin: "33px 0 35px 11px" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {form_title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={16}>
          <div className="is-flex flex-direction-row stock-category-search">
            <div style={{ width: "200px", margin: "30px 10px" }}>
              <SelectFieldGroup
                value={search_state.category?.name}
                onSearch={(value) => onCategorySearch({ value, setOptions })}
                onChange={(index) => {
                  const category = options.categories?.[index] || null;
                  setSearchState((prevState) => ({
                    ...prevState,
                    category,
                  }));
                }}
                formItemLayout={null}
                data={options.categories}
                column="name"
              />
            </div>

            <Searchbar
              name="search_keyword"
              onSearch={(value, e) => {
                e.preventDefault();
                onSearch({
                  page: 1,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: {
                    ...search_state,
                    product_type,
                  },
                });
              }}
              onChange={(e) => setSearchKeyword(e.target.value)}
              value={search_keyword}
              onNew={() => {
                setState({
                  ...initialValues,
                  category: { ...search_state.category },
                  branch_pricing: [
                    ...branches.map((o) => {
                      return {
                        branch: o,
                        price: "",
                        wholesale_price: "",
                      };
                    }),
                  ],
                });
                setRecords([]);
              }}
            />
          </div>
        </Col>
      </Row>

      <div
        style={{
          background: "#fff",
          padding: 24,
          minHeight: 280,
          borderRadius: 10,
        }}
      >
        <span className="module-title">
          {isEmpty(records) && (
            <i
              className="fas fa-chevron-left title-back-button"
              onClick={() => {
                onSearch({
                  page: current_page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: {
                    ...search_state,
                    product_type,
                  },
                });
              }}
            ></i>
          )}
          {form_title}
        </span>
        <Divider />
        {isEmpty(records) ? (
          <Form initialValues={initialValues}>
            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Name"
                  name="name"
                  error={errors.name}
                  formItemLayout={smallFormItemLayout}
                  value={state.name}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
              <Col span={12}>
                <SelectFieldGroup
                  label="Category"
                  value={state.category?.name}
                  onSearch={(value) =>
                    onCategorySearch({ value, options, setOptions })
                  }
                  onChange={(index) => {
                    const category = options.categories?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      category,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.categories}
                  column="name"
                  onAddItem={() => categoryFormModal.current.open()}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Unit of Measure"
                  name="unit_of_measure"
                  error={errors.unit_of_measure}
                  formItemLayout={smallFormItemLayout}
                  value={state.unit_of_measure}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
              <Col span={12}>
                <SimpleSelectFieldGroup
                  label="Type"
                  name="product_type"
                  value={state.product_type}
                  onChange={(value) => {
                    onChange({
                      key: "product_type",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors?.approval_status}
                  formItemLayout={smallFormItemLayout}
                  options={product_type_options}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  step={0.01}
                  type="number"
                  label="Cost"
                  name="cost"
                  error={errors.cost}
                  formItemLayout={smallFormItemLayout}
                  value={state.cost}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  step={0.01}
                  type="number"
                  label="Price"
                  name="price"
                  error={errors.price}
                  formItemLayout={smallFormItemLayout}
                  value={state.price}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  step={0.01}
                  type="number"
                  label="Reorder Level"
                  name="reorder_leve"
                  error={errors.reorder_leve}
                  formItemLayout={smallFormItemLayout}
                  value={state.reorder_leve}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  step={0.01}
                  type="number"
                  label="Reorder Quantity"
                  name="reorder_quantity"
                  error={errors.reorder_quantity}
                  formItemLayout={smallFormItemLayout}
                  value={state.reorder_quantity}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
            </Row>
            <Row>
              {state.product_type === MENU_ITEM && (
                <Col span={12}>
                  <SelectFieldGroup
                    label="Printer Station"
                    name="printer_station"
                    value={state.printer_station?.name || ""}
                    onChange={(index) => {
                      setState((prevState) => ({
                        ...prevState,
                        printer_station: options.printers?.[index] || null,
                      }));
                    }}
                    onSearch={onPrinterStationSearch}
                    error={errors.printer_station}
                    formItemLayout={smallFormItemLayout}
                    data={options.printers}
                    onFocus={() => {
                      onPrinterStationSearch("");
                    }}
                  />
                </Col>
              )}
            </Row>

            <CheckboxFieldGroup
              label="Disabled"
              name="disabled"
              error={errors.disabled}
              formItemLayout={formItemLayout}
              checked={state.disabled}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />

            {state.product_type === MENU_ITEM && [
              <CheckboxFieldGroup
                label="Is GC"
                name="is_gc"
                onChange={(e) => {
                  onChange({
                    key: e.target.name,
                    value: e.target.checked,
                    setState,
                  });
                }}
                error={errors.is_gc}
                checked={state.is_gc}
                formItemLayout={formItemLayout}
              />,
              <CheckboxFieldGroup
                label="Taxable"
                name="taxable"
                onChange={(e) => {
                  onChange({
                    key: e.target.name,
                    value: e.target.checked,
                    setState,
                  });
                }}
                error={errors.taxable}
                checked={state.taxable}
                formItemLayout={formItemLayout}
              />,
              <CheckboxFieldGroup
                label="Inventoriable"
                name="is_inventoriable"
                onChange={(e) => {
                  onChange({
                    key: e.target.name,
                    value: e.target.checked,
                    setState,
                  });
                }}
                error={errors.is_inventoriable}
                checked={state.is_inventoriable}
                formItemLayout={formItemLayout}
              />,
              state.taxable && (
                <RadioGroupFieldGroup
                  label="Type of Senior Discount"
                  name="type_of_senior_discount"
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                  error={errors.type_of_senior_discount}
                  value={state.type_of_senior_discount}
                  options={senior_discount_options}
                  formItemLayout={formItemLayout}
                />
              ),

              <Table
                dataSource={state.raw_materials}
                columns={raw_materials_column}
                rowKey="_id"
              />,
            ]}

            <Form.Item className="m-t-1" {...tailFormItemLayout}>
              <div className="field is-grouped">
                <Button
                  className="black-yellow control"
                  onClick={() => {
                    const raw_materials = [
                      ...(state.raw_materials || []),
                    ].filter((o) => {
                      return (
                        !isEmpty(o.raw_material?._id?.toString()) &&
                        !isEmpty(o.raw_material_quantity)
                      );
                    });

                    onSubmit({
                      values: {
                        ...state,
                        raw_materials,
                      },
                      auth,
                      url,
                      setErrors,
                      setState,
                      date_fields,
                      setLoading,
                      cb: () => {
                        onSearch({
                          page: current_page,
                          page_size,
                          search_keyword,
                          url,
                          setRecords,
                          setTotalRecords,
                          setCurrentPage,
                          setErrors,
                          advance_search: {
                            ...search_state,
                            product_type,
                          },
                        });
                      },
                    });
                  }}
                >
                  Save
                </Button>
                {!isEmpty(state._id) ? (
                  <Button
                    type="danger"
                    className="control"
                    icon={<i className="fa-solid fa-xmark pad-right-8"></i>}
                    onClick={() => {
                      onDelete({
                        id: state._id,
                        url,
                      });
                      setState({ ...initialValues });
                    }}
                  >
                    Delete
                  </Button>
                ) : null}
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    onSearch({
                      page: current_page,
                      page_size,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      advance_search: {
                        ...search_state,
                        product_type,
                      },
                    });
                  }}
                >
                  Exit
                </Button>
              </div>
            </Form.Item>
          </Form>
        ) : (
          <div>
            <div>
              <Row>
                <Col span={24}>
                  <CheckboxFieldGroup
                    label="Display Raw Mats"
                    name="display_raw_mats"
                    onChange={(e) => {
                      setDisplayRawMats(e.target.checked);
                    }}
                    checked={display_raw_mats}
                    formItemLayout={formItemLayout}
                  />
                </Col>
              </Row>
            </div>
            <Table
              dataSource={records}
              columns={records_column}
              rowKey={(record) => record._id}
              onRow={(record, index) => {
                return {
                  onDoubleClick: (e) => {
                    edit({
                      record,
                      setState: (record) => {
                        setState({
                          ...record,
                          raw_materials: [
                            ...record.raw_materials,
                            {
                              ...initialRawMaterials,
                            },
                          ],
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  },
                };
              }}
              pagination={{
                current: current_page,
                defaultCurrent: current_page,
                onChange: (page, page_size) => {
                  setPageSize(page_size);
                  onSearch({
                    page,
                    page_size,
                    search_keyword,
                    url,
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: {
                      ...search_state,
                      product_type,
                    },
                  });
                },
                total: total_records,
                pageSize: page_size,
              }}
            />
          </div>
        )}
      </div>
    </Content>
  );
}
